import styled from 'styled-components'

export const Wrapper = styled.div`
  & > div > div > div > .MuiDataGrid-columnsContainer {
    background-color: #222;
    color: white;
  }

  span {
    color: red;
  }
`
